module.exports = __webpack_public_path__ + "static/media/Purple_Chat_Bubble.42941b20.png";